import * as React from 'react';
import classes from './TableWithActionColumn.module.scss';
import { Table } from '../Table';
import { Void } from '../../../models/basic-objects';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { SquareButton } from '../../actions/SquareButton';

export type TableColumnsType = {
  header: string;
  label: JSX.Element | string;
};

export type TableColumnActionType = {
  action: Void;
  icon: SquareButtonIconsEnum;
  disabled?: boolean;
  tooltip?: string;
};

export type TableRowType = {
  columns: TableColumnsType[];
  actions: TableColumnActionType[];
};

export type TableWithActionColumnViewProps = {
  rows: TableRowType[];
};

export const TableWithActionColumnView = ({ rows }: TableWithActionColumnViewProps): JSX.Element => {
  // Extracting all unique headers from rows
  const headersSet = new Set<string>();
  rows.forEach(row => {
    row.columns.forEach(column => {
      headersSet.add(column.header);
    });
  });

  const headers = Array.from(headersSet); // Converting set to array

  return (
    <div className={classes.TableWithActionColumn}>
      <Table tableStyle={'stacked_scrolling'}>
        <>
          <thead>
            <tr>
              {headers.map(header => (
                <th key={`header-${header}`}>{header}</th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr key={`row-${rowIdx}`}>
                {headers.map((header, headerIdx) => {
                  const col = row.columns.find(column => column.header === header);
                  return <td key={`cell-${headerIdx}-${rowIdx}`}>{col ? col.label : ''}</td>;
                })}
                <td>
                  {row.actions.map((action, actionIdx) => (
                    <SquareButton
                      key={`action-${rowIdx}-${actionIdx}`}
                      action={action.action}
                      icon={action.icon}
                      type={'transparent'}
                      disabled={action.disabled || false}
                    />
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </>
      </Table>
    </div>
  );
};
